/**
 * Code to represent whether value is net (inclusive of tax) or gross.
 * tag: 430
 * @readonly
 * @enum {number} (int)
 */
export enum NetGrossInd {
  /** Net */
  Net = 1,
  /** Gross */
  Gross = 2,
}
